import {
  useCheckPermissions,
  PermOp,
} from '@user/store/authorization/permissions'
import {
  classifyKnockStatusVariant,
  KnockStatusVariantKind,
} from './knockStatusVariant'

// Update permission gating the clear action (mirrors the backend Operations.Update). Accepts a map
// variant or entityType in any casing; the variant taxonomy lives in knockStatusVariant.
const PERM_OP_BY_KIND: Record<KnockStatusVariantKind, PermOp> = {
  opportunity: 'opportunities_update',
  draftLead: 'pending_leads_update',
  lead: 'leads_update',
}

export function useKnockStatusEditPermission(variantOrEntityType: string) {
  return useCheckPermissions(
    PERM_OP_BY_KIND[classifyKnockStatusVariant(variantOrEntityType)],
  )
}
